import { render, staticRenderFns } from "./photoShow.vue?vue&type=template&id=29beb7d7&scoped=true"
import script from "./photoShow.vue?vue&type=script&lang=js"
export * from "./photoShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29beb7d7",
  null
  
)

export default component.exports